import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';
import { faCheck } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'kb-in-cart-label',
    templateUrl: './in-cart-label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, FontAwesomeModule],
})
export class InCartLabelComponent {
    @Input()
    inCartQty: number | undefined;
    check = faCheck;
}
